export enum CheckoutType {
  Order = 0,
  Offer = 1,
  GuestOrder = 2,
  ShoppingCartInquiry = 3
}
